module.exports = __webpack_public_path__ + "static/media/symbol-prepick.ed0156dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-prepick.svg
// module id = ./src/assets/images/symbol-prepick.svg
// module chunks = 0